import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import components_client_ZB1W0EeH0E from "/vercel/path0/node_modules/nuxt-swiper/dist/runtime/plugins/components.client.js";
import unocss_MzCDxu9LMj from "/vercel/path0/.nuxt/unocss.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_0lGnkXnTqM from "/vercel/path0/node_modules/@shopware-pwa/nuxt3-module/plugin.ts";
import ssr_plugin_B4ptqVdIfe from "/vercel/path0/node_modules/@vueuse/nuxt/ssr-plugin.mjs";
import AdminApiClient_d2btaPNewR from "/vercel/path0/plugins/AdminApiClient.ts";
import GtmClient_WcnZ98bxRe from "/vercel/path0/plugins/GtmClient.js";
import history_navigation_client_54bHkaZl3c from "/vercel/path0/plugins/history-navigation.client.ts";
import recaptcha_W4US4xmBV6 from "/vercel/path0/plugins/recaptcha.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  components_client_ZB1W0EeH0E,
  unocss_MzCDxu9LMj,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_0lGnkXnTqM,
  ssr_plugin_B4ptqVdIfe,
  AdminApiClient_d2btaPNewR,
  GtmClient_WcnZ98bxRe,
  history_navigation_client_54bHkaZl3c,
  recaptcha_W4US4xmBV6
]